<template>
  <v-app id="main_content" class="main-content">
    <AppHeader />
    <v-layout id="main-section">
      <MainLayout />
      <Navigation />
    </v-layout>
    <FooterLayout />
    <NotifyMain />
  </v-app>
</template>


<script>
import AppHeader from "@/components/Layouts/HeaderLayout";
import MainLayout from "@/components/Layouts/MainLayout";
import Navigation from "@/components/Layouts/NavigationLayout";
import FooterLayout from "@/components/Layouts/FooterLayout";
import NotifyMain from "@/components/Notifications/NotifyMain";

export default {
  name: 'App',
  data: () => ({
    //
  }),
  components: {
    AppHeader,
    MainLayout,
    Navigation,
    FooterLayout,
    NotifyMain,
  }
}
</script>

<style lang="scss">
  @import "@mdi/font/css/materialdesignicons.css";
  @import "vuetify/styles";
  @import "./sass/Theme.scss";
</style>
